import { calcLocalOther } from "./local-other";
import { calcRepeat } from "./repeat";
import { calcCorrectionTrial } from "./trial";
import { calcUnderreporting } from "./underreporting";
import { isDefined } from "../../../../../../lib/common";
import { UMIData } from "../../../../../reference-source-data";
import Big from "big.js";
import { calcIBBY } from "./ibby";
import { DemandForecastResult } from "../../../../../../types/request/report/demand-forecast";

export const calcDemandForecast = (
	trialBeforeCorrection: Big,
	umi: UMIData,
	gRepeat: number,
	correctionFactor: Big | undefined,
): DemandForecastResult => {
	// (A)トライアル購入数量 (補正後)
	const trialExcludeUnreported = isDefined(correctionFactor)
		? calcCorrectionTrial(trialBeforeCorrection, correctionFactor)
		: trialBeforeCorrection;
	// (B) リピート購入数量 = (A) x ([購入者購入数量]-1)
	const repeatExcludeUnreported = calcRepeat(trialExcludeUnreported, gRepeat);
	// (C) トライアル申告漏れ = (A) x ([SLCI申告漏れ補正係数]-1)
	// (D) リピート申告漏れ = (B) x ([SLCI申告漏れ補正係数]-1)
	const { trial: trialUnreported, repeat: repeatUnreported } = calcUnderreporting(
		trialExcludeUnreported,
		repeatExcludeUnreported,
		umi.gUnreport,
	);
	// トライアル数量合計
	const trial = trialExcludeUnreported.add(trialUnreported);
	// リピート数量
	const repeat = repeatExcludeUnreported.add(repeatUnreported);
	// (E+F+G) ローカルその他数量 = (A+B) x [gRatio_LocalOther]
	const localOther = calcLocalOther(trialExcludeUnreported, repeatExcludeUnreported, umi.gRatio_LocalOther);
	// (H) IBBY数量 = (A+B) x [gRatio_IBBY]
	const ibby = calcIBBY(trialExcludeUnreported, repeatExcludeUnreported, umi.gRatio_IBBY);
	// 合計
	const total = trialExcludeUnreported
		.add(repeatExcludeUnreported)
		.add(trialUnreported)
		.add(repeatUnreported)
		.add(localOther)
		.add(ibby);
	return {
		trialBeforeCorrection: trialBeforeCorrection.toNumber(), // (A’) トライアル購入数量 (補正前)
		trialExcludeUnreported: trialExcludeUnreported.toNumber(), // (A)トライアル購入数量 (補正後)
		repeatExcludeUnreported: repeatExcludeUnreported.toNumber(), //  (B) リピート購入数量 = (A) x ([購入者購入数量]-1)
		trialUnreported: trialUnreported.toNumber(), // (C) トライアル申告漏れ = (A) x ([SLCI申告漏れ補正係数]-1)
		repeatUnreported: repeatUnreported.toNumber(), // (D) リピート申告漏れ = (B) x ([SLCI申告漏れ補正係数]-1)
		localOther: localOther.toNumber(), // (E+F+G) ローカルその他数量 = (A+B) x [gRatio_LocalOther]
		ibby: ibby.toNumber(), // IBBY数量 = (A+B) x [gRatio_IBBY]
		/** 計算に利用 */
		trial: trial.toNumber(),
		repeat: repeat.toNumber(),
		total: total.toNumber(),
	};
};
